'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paths = require('./paths');

var _getEventsForStage = require('./getEventsForStage');

var _getEventsForStage2 = _interopRequireDefault(_getEventsForStage);

var _setCurrentEvent = require('./setCurrentEvent');

var _setCurrentEvent2 = _interopRequireDefault(_setCurrentEvent);

var _getEvent = require('../events/getEvent');

var _getEvent2 = _interopRequireDefault(_getEvent);

var _paths2 = require('../../actions/events/paths');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function (feis_id, stageId) {
  var resetCurrentEvent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return function (dispatch, getState) {
    dispatch({
      feis_id: feis_id,
      stageId: stageId,

      type: 'SET_CURRENT_STEWARDING_STAGE'
    });

    if (!resetCurrentEvent) {
      return Promise.resolve();
    }
    var eventsPromise = dispatch((0, _getEventsForStage2.default)(feis_id, stageId));
    var eventsForCurrentStage = void 0;
    return Promise.all([eventsPromise]).then(function () {
      eventsForCurrentStage = (0, _paths.getEventsOnStage)(getState(), stageId).filter(function (e) {
        return !e.get('placeholder');
      });
      if (eventsForCurrentStage && eventsForCurrentStage.size > 0) {
        var entireEventPromises = eventsForCurrentStage.map(function (event) {
          return dispatch((0, _getEvent2.default)(feis_id, event.get('id')));
        });
        return Promise.all(entireEventPromises);
      } else {
        return dispatch((0, _setCurrentEvent2.default)(feis_id, undefined));
      }
    }).then(function () {
      eventsForCurrentStage = eventsForCurrentStage.map(function (ev) {
        return (0, _paths2.getEvent)(getState(), ev.get('id')).merge(ev);
      });

      var currentEventList = eventsForCurrentStage.filter(function (e) {
        return e.get('is_ci_closed') === 0 || !e.get('is_ci_closed');
      });

      var currentEventId = getState().getIn(['stages', 'ui', feis_id, 'currentEvent']);
      var currentEvent = currentEventList.find(function (e) {
        return e.get('id') === currentEventId;
      });

      if (!currentEvent && currentEventList.size > 0) {
        currentEventId = currentEventList.get(0).get('id');
        currentEvent = currentEventList.find(function (e) {
          return e.get('id') === currentEventId;
        });
      }

      return currentEvent && dispatch((0, _setCurrentEvent2.default)(feis_id, currentEvent.get('id'), currentEvent.get('participants') > 0 ? true : false));
    });
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/stages/setCurrentStage.js
// module id = 110
// module chunks = 0